module.exports = __webpack_public_path__ + "img/filtros.6ebb52d5.svg";